import React from 'react';
import {
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import EmailIcon from '@mui/icons-material/Email';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { openSocialShare } from './utils/socialShareLinks';

const PLATFORMS = [
    { id: 'twitter', label: 'Twitter', icon: TwitterIcon },
    { id: 'facebook', label: 'Facebook', icon: FacebookIcon },
    { id: 'linkedin', label: 'LinkedIn', icon: LinkedInIcon },
    { id: 'whatsapp', label: 'WhatsApp', icon: WhatsAppIcon },
    { id: 'telegram', label: 'Telegram', icon: TelegramIcon },
    { id: 'email', label: 'Email', icon: EmailIcon },
];

export const ShareMenu = ({
    anchorEl,
    open,
    onClose,
    shareData,
    onPlatformClick,
    showCopyLink = true,
    onCopyLink,
}) => {
    const handlePlatformClick = (platform) => {
        if (onPlatformClick) {
            onPlatformClick(platform);
        } else {
            openSocialShare(platform, shareData);
        }
        onClose();
    };

    const handleCopyLink = () => {
        if (onCopyLink) {
            onCopyLink();
        }
        onClose();
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
        >
            {PLATFORMS.map((platform) => {
                const Icon = platform.icon;
                return (
                    <MenuItem
                        key={platform.id}
                        onClick={() => handlePlatformClick(platform.id)}
                    >
                        <ListItemIcon>
                            <Icon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>{platform.label}</ListItemText>
                    </MenuItem>
                );
            })}
            {showCopyLink && (
                <MenuItem onClick={handleCopyLink}>
                    <ListItemIcon>
                        <ContentCopyIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Copy Link</ListItemText>
                </MenuItem>
            )}
        </Menu>
    );
};

